import { render } from "./Arena_Avatar.vue?vue&type=template&id=70435838&scoped=true"
import script from "./Arena_Avatar.vue?vue&type=script&lang=js"
export * from "./Arena_Avatar.vue?vue&type=script&lang=js"

import "./Arena_Avatar.vue?vue&type=style&index=0&id=70435838&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70435838"]])

export default __exports__